import { createFileRoute } from "@tanstack/react-router";

import Syncs from "@/features/syncs/Syncs";
import SideNavLayout from "@/layouts/SideNavLayout";
import { SyncsMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/syncs/")({
  component: () => (
    <SideNavLayout menu={<SyncsMenu />}>
      <Syncs />
    </SideNavLayout>
  ),
});
